import { Badge as BokehBadge, type BadgeProps } from '@vimeo/bokeh';
import { secondsToDisplay } from '@vimeo/core/libs/date';
import { translate } from '@vimeo/i18n-runtime';

import { type BaseVideoCardProps } from './types';
import { OPACITY_TRANSITION } from '../../utils/constants';

const Badge = (props: BadgeProps) => (
  <BokehBadge
    size="sm"
    variant="timestamp"
    transition={OPACITY_TRANSITION}
    _groupHover={{ opacity: 0 }}
    {...props}
  />
);

export const VideoCardBadge = ({
  duration,
  trackStatus,
}: {
  duration?: number;
  trackStatus?: BaseVideoCardProps['trackStatus'];
}) => {
  switch (trackStatus) {
    case 'playing':
      return <Badge>{translate('Now playing')}</Badge>;
    case 'upcoming':
      return <Badge>{translate('Upcoming')}</Badge>;
    case 'live':
      return <Badge variant="mature">{translate('LIVE')}</Badge>;
    default:
      if (!duration) return null;
      return <Badge>{secondsToDisplay(duration)}</Badge>;
  }
};
